import { render, staticRenderFns } from "./_compositionEnglish.vue?vue&type=template&id=cb06c1de"
import script from "./_compositionEnglish.vue?vue&type=script&lang=js"
export * from "./_compositionEnglish.vue?vue&type=script&lang=js"
import style0 from "./_compositionEnglish.vue?vue&type=style&index=0&id=cb06c1de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports